import { BattlePage } from "@/battle/battle-page";
import { DashboardPage } from "@/ui/dashboard-page";
import { RootLayout } from "@/ui/root-layout";
import { CurrentUserFetcher } from "@indietabletop/appkit";
import { Suspense } from "react";
import { Redirect, Route, Switch } from "wouter";
import { AccountPage } from "../account-view";
import { ArmiesPage } from "../armies-page";
import { ArmyPages } from "../army-detail-page";
import { ChangelogPages } from "../changelog";
import { FortunePage } from "../fortune/fortune-page";
import { HelpPages } from "../help";
import { useScrollRestoration } from "../hooks/use-scroll-restoration";
import { JoinPage } from "../join-page";
import { LoadingIndicator } from "../loading-indicator";
import { LoginPage } from "../login-page";
import { MainLayout } from "../main-layout";
import { PrintArmyPage } from "../print-army-page";
import { QuickStartKeywords } from "../quick-start-keywords";
import { QuickStartPage } from "../quick-start-page";
import { ResetPasswordPage } from "../reset-password-page";
import { hrefs } from "../root-layout/fmt";
import { RulesPage } from "../RulesPage/RulesPage";
import { UserSettingsPage } from "../settings-page";
import { SharedArmyPages } from "../shared-army-detail-page";
import { TargetNumbers } from "../target-numbers";
import { UnitProfiles } from "../unit-profiles";
import { CheckoutSuccessPage } from "./CheckoutSuccessPage/CheckoutSuccessPage";

export function App() {
  useScrollRestoration();

  return (
    <RootLayout>
      <Suspense fallback={<LoadingIndicator />}>
        <Switch>
          <Route path="/print/a/:armyId" component={PrintArmyPage} />

          <Route>
            <MainLayout>
              <Switch>
                <Route path="/downloads">
                  <Redirect replace to={hrefs.buy({ note: "loginNeeded" })} />
                </Route>

                <Route path="/login" component={LoginPage} />

                <Route path="/password" component={ResetPasswordPage} />

                <Route path="/join" component={JoinPage} />

                <Route>
                  <CurrentUserFetcher>
                    <Switch>
                      <Route path="/" component={DashboardPage} />

                      <Route path="/battle" component={BattlePage} />

                      <Route path="/fortune" component={FortunePage} />

                      <Route path="/army" component={ArmiesPage} />

                      <Route path="/army/a/:armyId" nest>
                        <ArmyPages />
                      </Route>

                      <Route path="/army/s/:shareId" nest>
                        <SharedArmyPages />
                      </Route>

                      <Route path="/rules" component={RulesPage} />

                      <Route path="/rules/quick-start" nest>
                        <Switch>
                          <Route path="/" component={QuickStartPage} />
                          <Route path="/keywords" component={QuickStartKeywords} />
                          <Route path="/profiles" component={UnitProfiles} />
                          <Route path="/target-numbers" component={TargetNumbers} />
                        </Switch>
                      </Route>

                      <Route path="/quick-start">
                        <Redirect replace to="/rules/quick-start" />
                      </Route>

                      <Route path="/settings" component={UserSettingsPage} />

                      <Route path="/account" component={AccountPage} />

                      <Route path="/checkout/sessions/:sessionId">
                        <CheckoutSuccessPage />
                      </Route>

                      <Route path="/changelog" nest>
                        <ChangelogPages />
                      </Route>

                      <Route path="/help" nest>
                        <HelpPages />
                      </Route>
                    </Switch>
                  </CurrentUserFetcher>
                </Route>
              </Switch>
            </MainLayout>
          </Route>
        </Switch>
      </Suspense>
    </RootLayout>
  );
}
